import type { Component } from "solid-js";

interface SwitchButtonProps {
  icon: Component<{ class?: string }>;
  onClick?: () => void;
  "aria-label"?: string;
  active?: boolean;
  class?: string;
}

export const SwitchButton: Component<SwitchButtonProps> = (props) => {
  return (
    <button
      type="button"
      class="w-8 h-8 p-1.5 rounded-full bg-transparent transition-colors duration-200 focus:outline-none relative z-10 cursor-pointer"
      style={{
        color: props.active ? "var(--color-on-primary)" : "var(--color-on-surface-variant)",
      }}
      onClick={props.onClick}
      aria-label={props["aria-label"]}
    >
      <props.icon class={`w-5 h-5 ${props.class || ""}`} />
    </button>
  );
};
